const observeSections = () => {
    const doActions = (entry) => {
        const {
            target: el,
            isIntersecting: intersecting
        } = entry;

        if (intersecting) {
            el.classList.add("isIntersecting");
            return;
        }

        if (entry.boundingClientRect.y > 0) {
            el.classList.remove("isIntersecting");
        }
    }

    const observerCallback = (entries) => {
        entries.forEach((entry) => {
            doActions(entry);
        });
    };

    const useSectionObserver = (el) => {
        const defaultOpts = {
            "rootMargin": "70px",
            "threshold": ".5"
        };

        const options = JSON.parse(el.getAttribute("data-x-observer-options")) || defaultOpts;
        const observer = new IntersectionObserver(observerCallback, options)

        observer.observe(el);
    }

    const observableSections = document.querySelectorAll("[data-x-observer]");

    [].forEach.call(observableSections, el => useSectionObserver(el));
}

window.addEventListener("DOMContentLoaded", observeSections);